import React from 'react';
import QtySelector from '../QtySelector/QtySelector';
import Currency from '../../core/Currency/Currency';
import './ProductItem.scss';

export interface IProductItem {
    codart: string,
    desart: string,
    familia?: string,
    subfamilia?: string,
    price: number,
    imgUrl?: string,
    showCart: boolean
};

const ProductItem: React.FC<IProductItem> = (articulo: IProductItem) => {
    const { codart, desart, familia, subfamilia, price, imgUrl, showCart } = articulo;

    const renderCart = () => {
        if (showCart) {
            return (
                <div className="QtyCell">
                    <QtySelector 
                        desart={desart}
                        codart={codart} 
                        price={price}
                        isCheckout={false}
                    />
                </div>
            );
        }
    };

    return (
        <div className="col-lg-4 col-md-6 ">
            <div className="ProductItem">
                <div className="ImgContainer">
                    <img 
                        alt={desart}
                        className={!imgUrl ? 'notAvailable' : ''}
                        src={imgUrl ? `http://mcsiles.com.ar/usuarios/linea2000/${imgUrl}` : './assets/no-disponible.jpg'} 
                    />
                </div>
                <div className="ContentContainer">
                    <h3 className="Desart">{desart.toUpperCase()}</h3>
                    <p className="Categorias">{familia || '-'} {subfamilia ? `> ${subfamilia}` : null}</p>
                    <p className="Price"><Currency value={price} /> <span className="icon sale"></span></p>
                    {renderCart()}
                </div>
            </div>
        </div>
    );
};

export default ProductItem;